import { MinervaLogoIcon } from "@minervaproject/fds";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { BrandingStore } from "src/store";

const styles = {
  container: {
    alignItems: "start",
    display: "inline-flex",
    height: "146px",
    width: "220px",
  },
  asset: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
};

const OrgLogo = ({ minervaLogo, orgId }) => {
  const [hasError, setHasError] = useState(false);
  const branding = useSelector(BrandingStore.selectors.find({ orgId }));
  const className = "absolute m10";

  if (minervaLogo) {
    return (
      <div className={className}>
        <MinervaLogoIcon />
      </div>
    );
  }

  if (hasError || !branding?.logo_url) return null;

  return (
    <div style={styles.container} className={className}>
      <img
        style={styles.asset}
        alt={branding.email_logo_filename}
        src={branding.email_logo_url}
        onError={() => setHasError(true)}
      />
    </div>
  );
};

export { OrgLogo };
